// src/services/tmdbApi.js
import axios from 'axios';

// Load API key from .env
const API_KEY = process.env.REACT_APP_TMDB_API_KEY;
const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://api.themoviedb.org/3';
const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || 'https://image.tmdb.org/t/p/';

// Check if API key exists and warn if missing
if (!API_KEY) {
  console.error(
    '⚠️ TMDb API key is missing! Please add REACT_APP_TMDB_API_KEY to your .env file.'
  );
}

// Helper: Get full image URL
export const getImageUrl = (path, size = 'w500') => {
  if (!path) return '';
  return `${IMAGE_BASE_URL}${size}${path}`;
};

// Fetch popular movies
export const getPopularMovies = async (page = 1) => {
  if (!API_KEY) return [];
  try {
    const response = await axios.get(`${BASE_URL}/movie/popular`, {
      params: { api_key: API_KEY, language: 'en-US', page },
    });
    return response.data.results;
  } catch (error) {
    console.error('Error fetching popular movies:', error.response?.data || error);
    return [];
  }
};

// Fetch movie details by ID
export const getMovieDetails = async (movieId) => {
  if (!API_KEY) return null;
  try {
    const response = await axios.get(`${BASE_URL}/movie/${movieId}`, {
      params: {
        api_key: API_KEY,
        language: 'en-US',
        append_to_response: 'credits,videos,genres',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching movie details for ID ${movieId}:`, error.response?.data || error);
    return null;
  }
};

// Fetch popular TV shows
export const getPopularTvShows = async (page = 1) => {
  if (!API_KEY) return [];
  try {
    const response = await axios.get(`${BASE_URL}/tv/popular`, {
      params: { api_key: API_KEY, language: 'en-US', page },
    });
    return response.data.results;
  } catch (error) {
    console.error('Error fetching popular TV shows:', error.response?.data || error);
    return [];
  }
};

// Fetch TV show details by ID
export const getTvShowDetails = async (tvId) => {
  if (!API_KEY) return null;
  try {
    const response = await axios.get(`${BASE_URL}/tv/${tvId}`, {
      params: {
        api_key: API_KEY,
        language: 'en-US',
        append_to_response: 'credits,videos,genres',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching TV show details for ID ${tvId}:`, error.response?.data || error);
    return null;
  }
};

// Multi-search (movies + TV)
export const searchMulti = async (query) => {
  if (!API_KEY || !query.trim()) return [];
  try {
    const response = await axios.get(`${BASE_URL}/search/multi`, {
      params: {
        api_key: API_KEY,
        language: 'en-US',
        query,
        page: 1,
        include_adult: false,
      },
    });
    return response.data.results.filter(
      (item) => (item.media_type === 'movie' || item.media_type === 'tv') && item.poster_path
    );
  } catch (error) {
    console.error(`Error searching for "${query}":`, error.response?.data || error);
    return [];
  }
};
